import Fecha from "./Fecha";
import React from "react";
import { useNavigate } from "react-router-dom";

function Cuadrado({ year, month, consultas = [], fecha, cliente, usuarioActual }) {
    const navigate = useNavigate();

    // 1. Extraer la lista de consultas del objeto que llega del servidor
    const listaConsultas = Array.isArray(consultas) ? consultas : (consultas?.lista || []);

    const manejarNavegacion = (consultaExistente, numHorario) => {
        if (fecha === undefined) return;
        
        // Formateo de fecha para la URL de navegación (YYYY-MM-DD)
        const mPlusOne = month + 1;
        const fFormatted = fecha < 10 ? `0${fecha}` : fecha;
        const mFormatted = mPlusOne < 10 ? `0${mPlusOne}` : mPlusOne;
        const dateStr = `${year}-${mFormatted}-${fFormatted}`;

        // Validación para clientes: Si el turno no es suyo, no puede hacer clic para ver el detalle
        if (cliente && consultaExistente && consultaExistente[0]) {
            const c = consultaExistente[0];
            if (c.Cliente !== usuarioActual) return;
        }

        if (consultaExistente && consultaExistente[0]) {
            navigate(`/consulta/${dateStr}/${numHorario}`);
        } else {
            navigate(`/agendarConsulta/${dateStr}/${numHorario}`);
        }
    };

    let consultaH1, consultaH2, consultaH3;
    let tipo1, tipo2, tipo3;

    if (fecha !== undefined) {
        // 2. Filtrado por fecha usando la propiedad "Fecha" (con Mayúscula)
        const consultasDelDia = listaConsultas.filter(c => {
            if (!c.Fecha) return false;
            const d = new Date(c.Fecha);
            // Usamos UTC para que no haya desfase horario (importante en Uruguay)
            return d.getUTCFullYear() === year && 
                   d.getUTCMonth() === month && 
                   d.getUTCDate() === fecha;
        });

        // 3. Procesar cada horario usando la propiedad "Hora" (con Mayúscula)
        const procesarHorario = (h) => {
            const encontrada = consultasDelDia.find(c => Number(c.Hora) === h);
            if (!encontrada) return { con: undefined, txt: "" };
            
            // Traducción del tipo (usando "Tipo" con Mayúscula)
            let t = encontrada.Tipo;
            if (t == 1) t = "Castración";
            else if (t == 2) t = "Preñado";
            else t = "Reservado";
            
            return { con: [encontrada], txt: t };
        };

        const r1 = procesarHorario(1); consultaH1 = r1.con; tipo1 = r1.txt;
        const r2 = procesarHorario(2); consultaH2 = r2.con; tipo2 = r2.txt;
        const r3 = procesarHorario(3); consultaH3 = r3.con; tipo3 = r3.txt;
    }

    // 4. Lógica de Colores (Clases CSS)
    const obtenerClase = (consulta) => {
        let claseBase = 'hora-lg squareSize';
        
        if (!consulta || !consulta[0]) {
            return cliente ? `${claseBase} bg-libre` : claseBase;
        }

        const c = consulta[0];
        if (cliente) {
            // "bg-mio" si es el turno del usuario logueado, "bg-ocupado" si es de otro
            return (c.Cliente === usuarioActual) ? `${claseBase} bg-mio` : `${claseBase} bg-ocupado`;
        }
        // Para vista administrador
        return `${claseBase} hora-lg-occupied`;
    };

    // 5. Lógica de Texto visible (Nombre, Apellido y Tipo)
    const obtenerTexto = (consulta, tipo) => {
        if (!consulta || !consulta[0]) return "Libre";
        const c = consulta[0];
        
        // En vista cliente, si el turno es de otro, se oculta la información
        if (cliente && c.Cliente !== usuarioActual) return "Ocupado";
        
        const nombreStr = c.Nombre || "";
        const apellidoStr = c.Apellido || "";
        return `${nombreStr} ${apellidoStr} - ${tipo}`.trim();
    };

    // Render para días que no pertenecen al mes actual
    if (fecha === undefined) {
        return (
            <div className="horario squareSize">
                <Fecha fecha={fecha} />
                <div className="hora-lg-out squareSize"></div>
                <div className="hora-lg-out squareSize"></div>
                <div className="hora-lg-out squareSize"></div>
            </div>
        );
    }

    return (
        <div className="horario squareSize">
            <Fecha fecha={fecha} />
            <div onClick={() => manejarNavegacion(consultaH1, 1)} className={obtenerClase(consultaH1)}>
                {obtenerTexto(consultaH1, tipo1)}
            </div>
            <div onClick={() => manejarNavegacion(consultaH2, 2)} className={obtenerClase(consultaH2)}>
                {obtenerTexto(consultaH2, tipo2)}
            </div>
            <div onClick={() => manejarNavegacion(consultaH3, 3)} className={obtenerClase(consultaH3)}>
                {obtenerTexto(consultaH3, tipo3)}
            </div>
        </div>
    );
}

export default Cuadrado;